(function (Drupal, $) {
  Drupal.behaviors.productItem = {
    attach: function (context) {
      $(".product-item .toggle-body", context)
        .once("processed")
        .addClass("processed")
        .on("click", function () {
          var panel = $(this).closest(".product-item__resources-panel");
          if (panel.hasClass("enabled")) {
            $(this).children().toggleClass("d-flex");
            panel
              .toggleClass("expanded")
              .children(".product-item__resources-panel--body")
              .stop()
              .slideToggle(300);
          }
        });
      $(".product-item").each(function () {
        var $this = $(this);
        var body = $this.find(".product-item__summary");
        var initialHeight = body.outerHeight();
        if (initialHeight > 220) {
          body.addClass("expandable is-closed");
          body.css("max-height", initialHeight);
        }
      });

      $(".product-item .expand-summary", context)
        .once()
        .on("click", function () {
          $(this).parent().toggleClass("is-open is-closed");
        });
    },
  };
})(Drupal, jQuery);
